import type { OnboardingFormValues } from "./mergePrefillIntoFormValues.js";

type TaxValues = Pick<
  OnboardingFormValues,
  "managingDirector" | "vatNumber" | "taxNumber" | "registrationNumber"
>;

const TAX_FIELDS: (keyof TaxValues)[] = [
  "managingDirector",
  "vatNumber",
  "taxNumber",
  "registrationNumber",
];

/**
 * Whether a website lookup found at least one value of "Tax and legal
 * details". The lookup may answer any subset of them (today only the managing
 * director); one it did not answer counts as not found.
 */
export function lookupFoundTaxValue(
  prefill: Partial<Record<keyof TaxValues, string | null>>
): boolean {
  return TAX_FIELDS.some(field => (prefill[field] ?? "").trim() !== "");
}

/**
 * Whether "Tax and legal details" (with the managing director) is on the
 * business step: once a website lookup in this visit found one of its values,
 * or when the organisation already stores one, so they stay editable. A lookup
 * that found none of them keeps the section hidden.
 */
export function shouldShowTaxSection({
  lookupFound,
  initial,
}: {
  lookupFound: boolean;
  initial: TaxValues;
}): boolean {
  return lookupFound || TAX_FIELDS.some(field => initial[field].trim() !== "");
}
